/**
 * @fileoverview The root route.
 *
 * There is still nothing to list here, and there should not be. An author's
 * own index now exists at `pages.cloistr.xyz/<npub>`, but a GLOBAL directory of
 * everyone's pages is deferred: it has to fan out across a follow graph and it
 * is a moderation surface. A fake directory would be worse than an honest empty
 * front page.
 */

import { Link } from 'react-router-dom';

import { config } from '@/config/environment';
import { NEW_PAGE_PATH } from '@/services/nostr/pageLinks';

export function Home() {
  return (
    <div className="page-home">
      <h1>Pages</h1>
      <p>
        Open a page by its address: <code>{config.appHost}/naddr1…</code>
      </p>
      <p>
        Or list everything one author has published:{' '}
        <code>{config.appHost}/npub1…</code>
      </p>
      <p>
        <Link to={NEW_PAGE_PATH}>Write a page</Link> or{' '}
        <Link to="/site">make a site</Link> out of pages you have already written, or see{' '}
        <Link to="/mine">everything you publish</Link>.
      </p>
      <p className="page-home-note">
        A page&rsquo;s address names its author and its identifier, not a particular version,
        so a link keeps working after the page is edited.
      </p>
    </div>
  );
}
